<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template>
	<k-card-text :id="print_lesson_dom_id" class="k-lesson-card-text">
		<!-- LESSON_VARIANT B ("ENHANCED") -->
		<div v-if="lesson.lp_variant=='B'&&!show_print_dialog" class="k-lpe-alba-outer-outer">
			<!-- MENU FOR LESSON COMPONENTS/STAGES -->
			<div class="k-lpe-alba-menu-stages">
				<div v-if="lesson.standards.length>0"><k-hover v-slot:default="{hover}"><div class="k-lpe-alba-menu-stage-outer k-lpe-alba-menu-stage-complete" :style="hover?'opacity:1':''">
					<div v-bind="standards_component_left_bind()" @click="go_to_stage('standards')">
						<k-icon style="width:20px" :color="`${standards_component.lc_color} darken-4`" small class="mr-2">{{standards_component.lc_icon}}</k-icon>
						<div class="k-lpe-alba-menu-stage-label">{{ standards_component.lc_title }}</div>
						<k-spacer/>
						<k-icon v-show="hover" :color="`${standards_component.lc_color} darken-4`" small>fas fa-circle-arrow-right</k-icon>
					</div>
				</div></k-hover></div>

				<div v-for="(component, ci) in left_blocks" :key="component.lc_uuid">
					<!-- insert "groups" where needed -->
					<k-hover v-if="component.title" v-slot:default="{hover}"><div class="k-lpe-alba-menu-stage-outer" style="opacity:1">
						<div class="k-lpe-alba-menu-stage py-1" v-bind="left_block_component_bind(component)">
							<div class="k-lpe-alba-menu-stage-label"><b style="font-weight:900">{{component.title}}</b></div>
						</div>
					</div></k-hover>

					<div v-else>
						<div v-if="show_component(component)"><k-hover v-slot:default="{hover}"><div class="k-lpe-alba-menu-stage-outer k-lpe-alba-menu-stage-complete k-lpe-alba-menu-stage-hoveredx" :class="hover?'k-lpe-alba-menu-stage-hovered':''">
							<div class="k-lpe-alba-menu-stage" v-bind="left_block_component_bind(component)" @click="go_to_stage(component)">
								<k-icon style="width:20px" :color="`${mdlph[component.lc_uuid].lc_color} darken-4`" small class="mr-2">{{mdlph[component.lc_uuid].lc_icon}}</k-icon>
								<div class="k-lpe-alba-menu-stage-label">{{mdlph[component.lc_uuid].lc_title}}</div>
								<k-spacer/>
								<k-icon v-show="hover" :color="`${mdlph[component.lc_uuid].lc_color} darken-4`" small>fas fa-circle-arrow-right</k-icon>
							</div>
						</div></k-hover></div>
					</div>
				</div>
			</div>

			<!-- HOLDER FOR EACH STAGE, INCLUDING TITLE, STANDARDS, SPARKL ACTIVITY, AND RESOURCES -->
			<div class="k-lpe-alba-content"><div class="k-lpe-alba-content-inner">
				<div v-if="author_note" class="k-lpe-author-note" v-html="author_note"></div>

				<!-- STANDARDS -->
				<div v-if="lesson.standards.length>0" v-bind="standards_component_right_bind()" style="display:block;">
					<div class="d-flex align-center">
						<k-icon class="k-lpe-alba-section-header-icon" :color="`${standards_component.lc_color} darken-4`" @click="lesson.standards_showing=!lesson.standards_showing">{{standards_component.lc_icon}}</k-icon>
						<div class="k-lpe-alba-section-header-text mr-2 my-3" @click="lesson.standards_showing=!lesson.standards_showing">{{standards_component.lc_title}}</div>
						<k-btn small icon class="mr-2" aria-label="Standards" :color="`${standards_component.lc_color} darken-4`" @click="lesson.standards_showing=!lesson.standards_showing"><k-icon style="font-size:20px">fas {{lesson.standards_showing?'fa-angles-up':'fa-angles-down'}}</k-icon></k-btn>
						<div v-show="!lesson.standards_showing" style="display:flex" class="flex-wrap my-1">
							<CASEItemBtn @click="show_standard_in_satchel(s)" v-for="(s) in lesson.standards" :key="s.identifier" :btn_color="s.is_secondary?'#666':'primary'" :item="s" small :outer_class="'ma-1'" />
						</div>
					</div>
					<div k-expand-transition-XX><div v-show="lesson.standards_showing" class="mt-0">
						<div v-for="(s) in lesson.standards" :key="s.identifier" class="mt-2">
							<div class="d-flex k-lesson-standard-fullstatement">
								<CASEItemBtn @click="show_standard_in_satchel(s)" :btn_color="s.is_secondary?'#666':'primary'" :item="s" small :outer_class="'mr-2'" />
								<div>
									<div v-html="U.marked_latex(s.fullStatement)"></div>
									<div v-if="s==first_primary_standard && standard_supplemental_information" class="fr-view k-lesson-standard-suppinfo">
										<div class="k-lesson-standard-suppinfo-header"><b>Guidance from {{site_config.agency_name}}</b></div>
										<div class="px-2 pb-2" v-html="standard_supplemental_information"></div>
									</div>
								</div>
							</div>
						</div>
					</div></div k-expand-transition-XX>
				</div>
				
				<!-- LESSON COMPONENTS -->

				<div v-for="(component, ci) in left_blocks" :key="component.lc_uuid">
					<!-- insert "groups" where needed -->
					<div v-if="component.title" 
						class="k-lpe-alba-content-section k-lpe-alba-section-stage-complete k-lpe-alba-section-group"
						style="cursor:pointer" 
						v-bind="right_block_component_bind(component)"
						@click.stop="toggle_component_group_showing($event, component)"
					>
						<div class="d-flex align-center">
							<k-btn x-small dark class="mr-3" 
								style="width:64px"
								:color="group_showing[component.lc_uuid] ? 'rgba(0,0,0,0.2)' : `${component.color} darken-3`"
								@click.stop="toggle_component_group_showing($event, component)"
							>
								{{group_showing[component.lc_uuid]?'Hide':'Show'}}
								<k-icon small class="ml-1">fas {{group_showing[component.lc_uuid]?'fa-caret-up':'fa-caret-down'}}</k-icon>
							</k-btn>
							<b style="font-weight:900">{{component.title}}</b>
						</div>
					</div>

					<div v-else>
						<div v-show="show_component(component) && component_group_showing(component)" class="k-lpe-alba-content-section k-lpe-alba-section-stage-complete" :class="section_stage_css(component)" :style="section_stage_style(component)">
							<div class="d-flex align-center">
								<k-icon class="k-lpe-alba-section-header-icon" @click="toggle_stage(component)" :color="`${mdlph[component.lc_uuid].lc_color} darken-4`">{{mdlph[component.lc_uuid].lc_icon}}</k-icon>
								<div class="k-lpe-alba-section-header-text" v-bind="right_block_component_bind(component)" @click="toggle_stage(component)">{{mdlph[component.lc_uuid].lc_title}}</div>
								<div class="k-lpe-alba-section-view-guidance"
									v-if="view_guidance(component)"
									v-html="view_guidance(component)"
								></div>
							</div>
							<div v-if="section_text(component)" class="k-lpe-alba-section-summary-wrapper">
								<StumpyDiv ref="lc_stumpy_div"
									:min_height="200"
									:no_transition="true"
									:trigger="section_text(component)"
									:uuid="`${lesson.lesson_id}-${component.lc_uuid}`"
									@stumpy_toggle_show_full="component_stumpy_toggled(component.lc_uuid, $event)"
								>
									<div v-show="section_text(component)" class="k-lpe-alba-section-summary my-2 fr-view" v-html="section_text(component)"></div>
								</StumpyDiv>
								<div style="clear:both"></div> <!-- needed in case there is weird stuff in the section_text -->
							</div>

							<!-- MODEL RESPONSES FOR QUESTIONS -->
							<div v-if="component.lc_sparkl_model_response" class="mt-2 ml-5">
								<div style="font-size:14px"><b>Model response for question:</b></div>
								<div class="mt-1 fr-view" v-html="component.lc_sparkl_model_response"></div>
							</div>

							<!-- RESOURCES FOR NON-MATERIALS COMPONENTS -->
							<div v-if="component.lc_uuid!='materials' && asset_list[component.lc_uuid].length>0" class="mt-3">
								<LessonFeaturedAsset
									v-for="(asset) in asset_list[component.lc_uuid]"
									:key="asset.resource_id||asset.lesson_id"
									:asset="asset"
									:lc_color="mdlph[component.lc_uuid] ? mdlph[component.lc_uuid].lc_color : ''"
									@asset_clicked="show_resource(asset, null, 'from_quick_look')"
									@add_to_gc="add_to_gc(asset)"
									@lti_chooser_choose="lti_chooser_choose(asset)"
								></LessonFeaturedAsset>
							</div>

							<!-- RESOURCES FOR MATERIALS -->
							<div v-if="component.lc_uuid=='materials' && asset_list[component.lc_uuid].length>0" class="k-lesson-resource-collection mt-3 mb-2">
								<div v-for="(asset) in asset_list[component.lc_uuid]" :key="asset.resource_id||asset.lesson_id" class="k-resource-collection-activity-wrapper">
									<ResourceCollectionItem 
										ref="resource_collection_item" 
										:lesson_context="lesson" 
										:item="asset" 
										:option_overrides="resource_option_overrides(asset)"
										@copy_to_shadow_unit_finish="copy_to_shadow_unit_finish"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="site_config.not_agency_sanctioned_warning_lesson && !lesson.agency_sanctioned" class="mt-3 mb-2 px-5" style="font-size:12px; line-height:16px;" v-html="site_config.not_agency_sanctioned_warning_lesson"></div>
			</div></div>

		</div>

		<!-- LESSON VARIANT "A" ("TRADITIONAL") -->
		<div v-else class="px-1 pt-1 pb-3">
			<div v-if="author_note" class="k-lpe-author-note" v-html="author_note"></div>

			<div class="k-lesson-grouping elevation-2" v-if="lesson.standards.length>0">
				<div class="d-flex" @click="toggle_standards" style="cursor:pointer">
					<k-btn icon x-small color="indigo darken-2" class="mr-2" @click.stop="toggle_standards"><k-icon>fas {{lesson.standards_showing?'fa-caret-down':'fa-caret-right'}}</k-icon></k-btn>
					<div class="k-lesson-title-intro"><b>Learning Standards</b></div>
				</div>
				<k-expand-transition><div v-show="lesson.standards_showing"><div class="d-flex flex-wrap my-1"><CASEItemBtn v-for="(s) in lesson.standards" :key="s.identifier" :item="s" :framework_identifier="case_framework_identifier(s)" :selected_items="lesson.standards" small :outer_class="'ma-1'" /></div></div></k-expand-transition>
			</div>

			<div class="k-lesson-grouping elevation-2" v-if="false&&lesson.student_description">
				<div class="d-flex" @click="toggle_student_description" style="cursor:pointer">
					<k-btn icon x-small color="indigo darken-2" class="mr-2" @click.stop="toggle_student_description"><k-icon>fas {{lesson.student_description_showing?'fa-caret-down':'fa-caret-right'}}</k-icon></k-btn>
					<div class="k-lesson-title-intro"><b>Student-Facing Lesson Overview</b></div>
				</div>
				<k-expand-transition><div v-show="lesson.student_description_showing" style="background-color:#fff;border-radius:6px;padding:6px;margin-top:4px;">
					<div class="fr-view" v-html="U.render_latex(lesson.student_description)"></div>
				</div></k-expand-transition>
			</div>

			<div v-for="(component, ci) in left_blocks" :key="component.uuid" v-if="show_component(component)" class="k-lesson-component elevation-2" :class="component.lc_showing?'k-lesson-component-showing':''">
				<div v-if="lesson.lp_variant=='B'" class="k-lesson-component-title" @click="toggle_component(ci)">
					<div class="k-lesson-component-title-text">{{mdlph[component.lc_uuid].lc_title}}</div>
				</div>
				<div v-else class="k-lesson-component-title" @click="toggle_component(ci)">
					<div class="k-lesson-component-toggle-holder"><k-btn icon x-small color="indigo darken-2" @click.stop="toggle_component(ci)"><k-icon>fas {{component.lc_showing?'fa-caret-down':'fa-caret-right'}}</k-icon></k-btn></div>
					<div class="k-lesson-component-title-text" :class="'k-lesson-component-title-text-'+lesson_master.lesson_plan[ci].lc_weight">{{(lesson_master.lesson_plan[ci].lc_title)?lesson_master.lesson_plan[ci].lc_title:'Part '+(ci+1)}}</div>
					<div v-if="lesson_master.lesson_plan[ci].lc_weight" class="k-lesson-component-title-weight" :style="'flex-basis:' + lesson_master.lesson_plan[ci].lc_weight + '%'">{{lesson_master.lesson_plan[ci].lc_weight}}%</div>
				</div>
				<k-expand-transition><div v-show="component.lc_showing">
					<div v-if="lesson.lp_variant=='B'">
						<div class="k-lesson-component-content" v-html="section_text(component)"></div>
					</div>
					<div v-else>
						<div v-if="lesson_master.lesson_plan[ci].lc_guidance" class="k-lesson-component-guidance" v-html="lesson_master.lesson_plan[ci].lc_guidance"></div>
						<div class="k-lesson-component-content">
							<div v-for="(component_part, cpi) in component.lc_parts" :key="cpi" class="k-lesson-component-part-content">
								<div v-if="component.lc_parts.length>1" class="k-lesson-component-part-header">
									<div v-if="!component_part.lcp_title" class="mr-2">Part {{cpi+1}}</div>
									<div v-if="component_part.lcp_title" v-html="component_part.lcp_title"></div>
								</div>
								<div class="fr-view" v-html="U.render_latex(component_part.lcp_teacher_content)"></div>
							</div>
						</div>
						<!-- show lc_default_content from master if we don't have any teacher content -->
						<div v-if="component.lc_parts.length>0&&component.lc_parts[0].lcp_teacher_content==''&&lesson_master.lesson_plan[ci].lc_default_content" class="k-lesson-component-default-content">
							<div class="float-left mr-2"><b>“Looks like…”</b></div>
							<div class="fr-view" v-html="lesson_master.lesson_plan[ci].lc_default_content"></div>
						</div>
					</div>
				</div></k-expand-transition>
			</div>

			<div class="k-lesson-grouping elevation-2" v-if="lesson.resources.length>0">
				<div class="d-flex" @click="toggle_resources" style="cursor:pointer">
					<k-btn icon x-small color="indigo darken-2" class="mr-2" @click.stop="toggle_resources"><k-icon>fas {{lesson.resources_showing?'fa-caret-down':'fa-caret-right'}}</k-icon></k-btn>
					<div class="k-lesson-title-intro"><b>Lesson Resources</b></div>
				</div>
				<k-expand-transition><div v-show="lesson.resources_showing"><div class="k-lesson-resource-collection mt-2">
					<div v-for="(resource) in lesson.resources" :key="resource.resource_id" class="k-resource-collection-activity-wrapper">
						<ResourceCollectionItem 
							ref="resource_collection_item" 
							:lesson_context="lesson" 
							:item="resource" 
							@copy_to_shadow_unit_finish="copy_to_shadow_unit_finish"
						/>
					</div>
				</div></div></k-expand-transition>
			</div>
		</div>

	</k-card-text>
</template>

<script>
import goTo from 'vuetify/lib/services/goto'
import { mapState, mapGetters } from 'vuex'
import CASEItemBtn from '../standards/CASEItemBtn'
import StumpyDiv from '../utilities/StumpyDiv'
import LessonEnhancedMixin from './LessonEnhancedMixin'
import LessonFeaturedAsset from './LessonFeaturedAsset'

export default {
	name: 'LessonView',
	mixins: [LessonEnhancedMixin],
	components: {
		// have to this this way because of recursion in the components...
		ResourceCollectionItem: () => import('../resources/ResourceCollectionItem')
		, LessonFeaturedAsset, CASEItemBtn, StumpyDiv
	},
	props: {
		lesson: { required: true },
		print_lesson_dom_id: { type: String, required: false, default() { return U.new_uuid() } },
		show_print_dialog: { type: Boolean, required: false, default() { return false } },
	},
	data() { return {
		last_clicked_component: null,
	}},
	computed: {
		...mapState(['user_info', 'lesson_masters', 'default_lesson_master', 'site_config']),
		...mapGetters([]),
		lesson_master() {
			// TEMP: hard code master for variant B
			if (this.lesson.lp_variant == 'B') return window.variant_b_lesson_master_data
			
			// if we have a lesson_master_id, return the lesson master
			if (this.lesson.lesson_master_id) {
				let l = this.lesson_masters.find(x=>x.lesson_id==this.lesson.lesson_master_id)
				if (l) return l
			}
			// otherwise the lesson is its own master
			return this.lesson
		},
		// the following two will only be used for variant b
		lp_component_scheme() { return this.lesson_master.lp_component_schemes[this.lesson.lp_component_scheme] },
		mdlph() {
			return this.construct_mdlph()
		},
		standards_component() { return this.lesson_master.standards_component },

		// allow for schemes to combine components into the overview
		overview_content() {
			let html = ''
			let lpc = this.lesson.lesson_plan.find(x=>x.lc_uuid == 'overview')
			if (lpc) html = lpc.lc_content || ''

			// for each component, in scheme order
			let cl = 'mt-3'
			for (let group of this.lp_component_scheme.groups) {
				for (let lc_uuid of group.group_components) {
					let lpc = this.lesson.lesson_plan.find(x=>x.lc_uuid == lc_uuid)
					// if the component has content...
					if (!empty(lpc?.lc_content)) {
						// and this component's master has a lc_show_with_overview template
						let mc = this.mdlph[lc_uuid]
						let template = mc?.lc_show_with_overview
						if (!empty(template)) {
							// add the component's data to the overview
							template = `<div class="k-overview-sub-component ${cl}"><i class="${mc.lc_icon} fa-fw ml-3 mr-2 grey--text text--darken-2" style="margin-top:3px"></i>${template}</div>`
							html += template.replace(/\$1/, `<div class="ml-2">${lpc.lc_content}</div>`)
							cl = 'mt-1'
						}
					}
				}
			}

			return html
		},

		left_blocks() {
			// we use left_blocks as the iterator for lesson components in the UI.
			// for variant A lessons, just use the lesson_plan array
			if (this.lesson.lp_variant == 'A') {
				return this.lesson.lesson_plan
			}

			// in the viewer (as opposed to the editor), we show the same sections on the left and right
			let arr = []
			// put existing components in the order specified by the lp_component_scheme groups
			for (let group of this.lp_component_scheme.groups) {
				arr.push(group)

				let comp_included = false
				for (let lc_uuid of group.group_components) {
					let lpc = this.lesson.lesson_plan.find(x=>x.lc_uuid == lc_uuid) 

					// on the left side, only show components that have content
					if (lpc) {
						if (!this.component_empty(lpc)) {
							// also skip components that get put into the overview
							if (empty(this.mdlph[lpc.lc_uuid]?.lc_show_with_overview)) {
								arr.push(lpc)
								comp_included = true
							}
						}
					}
				}
				
				// if we didn't include anything from this group, pop the group back out
				if (!comp_included) arr.pop()
			}
			return arr
		},

		author_note() {
			// if site_config.lpc_show_author_note is 'no', we don't show this at all
			if (this.site_config.lpc_show_author_note == 'no') return ''

			// if agency_sanctioned...
			if (this.lesson.agency_sanctioned) {
				// use lpc_agency_sanctioned_author_note if we have one; otherwise use a default message
				if (!empty(this.site_config.lpc_agency_sanctioned_author_note)) {
					return this.site_config.lpc_agency_sanctioned_author_note
				}
				return `This Lesson Plan was created by ${this.site_config.agency_name}`

			// else created by someone else...
			} else {
				let creator_name
				if (!empty(this.lesson.creator_name)) {
					creator_name = this.lesson.creator_name
				} else if (this.user_info.user_id == this.lesson.creator_user_id) {
					creator_name = `${this.user_info.first_name} ${this.user_info.last_name}`
				} else {
					creator_name = `User ${this.lesson.creator_user_id}`
					// TODO: look up user name from user_id
				}

				if (this.lesson.lesson_template_id == 0) {
					return `This Lesson Plan was created by <b>${creator_name}</b>`
				}

				return `This Lesson Plan was created by <b>${creator_name}</b>, derived from <a href="/lesson/${this.lesson.lesson_template_id}" target="_blank">Lesson ID ${this.lesson.lesson_template_id}</a>`
			}
		},

	},
	watch: {
	},
	created() {
		// get lesson_masters if we haven't already done so
		this.$store.dispatch('get_lesson_masters').then(x=>{
			// then get the lesson itself if it isn't yet fully loaded
			if (!this.lesson.lesson_fully_loaded) {
				this.$store.dispatch('load_lesson', this.lesson).then(x=>{
					// console.warn('loaded lesson', object_copy(this.lesson))
				})
			}
		})
	},
	mounted() {
		vapp.lesson_view_component = this
		this.activate_section_text_copy_btns()

		// when we mount, make sure at least one group is showing
		this.show_at_least_one_group()
	},
	methods: {
		toggle_component(ci, val) {
			if (typeof(val) != 'boolean') val = !this.lesson.lesson_plan[ci].lc_showing
			this.$store.commit('set', [this.lesson.lesson_plan[ci], 'lc_showing', val])
		},

		toggle_resources(val) {
			if (typeof(val) !== 'boolean') val = !this.lesson.resources_showing
			this.$store.commit('set', [this.lesson, 'resources_showing', val])
		},

		toggle_student_description(val) {
			if (typeof(val) !== 'boolean') val = !this.lesson.student_description_showing
			this.$store.commit('set', [this.lesson, 'student_description_showing', val])
		},

		toggle_standards(val) {
			if (typeof(val) !== 'boolean') val = !this.lesson.standards_showing
			this.$store.commit('set', [this.lesson, 'standards_showing', val])
		},

		case_framework_identifier(item) {
			// if the item has a framework_identifier, send it
			if (item.framework_identifier) return item.framework_identifier

			// HACK: trace up through parents looking for a case_framework_identifier value (e.g. in CourseView); if found, use it
			// for newly-generated lessons, added standards will include the framework_identifier
			let parent = this.$parent
			while (parent) {
				if (parent.case_framework_identifier) {
					return parent.case_framework_identifier
				}
				parent = parent.$parent
			}

			// TODO: if we get to here, look in loaded frameworks, then use a service (or the item uri?) to look up the document
			return ''
		},

		/////////////////////////////////////////
		master_component(component) {
			return this.mdlph[component.lc_uuid]
		},

		show_component(component) {
			// for variant A components, check the is_empty method
			if (this.lesson.lp_variant == 'A') {
				return !component.is_empty()
			} else {
				return !this.component_empty(component)
			}
		},

		section_stage_css(component) {
			let mdc = this.master_component(component)
			let s = `k-lpe-alba-content-section-${component.lc_uuid}`
			// if (this.last_clicked_component == component) s += ` ${mdc?.lc_color} lighten-5 k-lpe-alba-section-stage-open_for_editing`
			if (this.last_clicked_component == component) s += ` k-lpe-alba-section-last-clicked ${mdc?.lc_color} lighten-5`
			else s += ` ${mdc?.lc_color} lighten-3`
			return s
		},

		section_stage_style(component) {
			let s = ''
			if (this.last_clicked_component == component) s += ''
			else s += `background-color:#fff!important`
			return s
		},

		view_guidance(component) {
			// send back the lc_view_guidance for the master component, if we have it
			let mdc = this.master_component(component)
			if (empty(mdc.lc_view_guidance)) return null

			let s = mdc.lc_view_guidance

			// do some subs...

			// this is CPS-specific
			if (s == '$tfg_link') {
				// look for the tfg resource... first look here
				let tfg_url = this.lesson.case_resource_extensions?.tfgURL
				if (!empty(tfg_url)) {
					//
					s = `For more information, refer to the lesson’s <a href="${tfg_url}" target="_blank" class="k-lesson-component-resource-anchor-link" data-resource-icon="fa-file-alt">Teacher Facilitation Guide</a>.`
				} else {
					s = 'For more information, refer to the lesson’s Teacher Facilitation Guide.'
				}
			}

			return s
		},

		// this is called when the user clicks on the left-side TOC item
		go_to_stage(component) {
			// determine if this stage's group is currently showing -- if the group was hidden, we will show it now
			let group_showing = this.component_group_showing(component)

			// if the group was hidden, always set last_clicked_component to the component
			if (!group_showing) {
				this.last_clicked_component = component

			// else set last_clicked_component to the clicked component, unless the user just clicked on the same component previously (meaning this is is basically toggling on/off)
			} else {
				if (this.last_clicked_component == component) this.last_clicked_component = null
				else this.last_clicked_component = component
			}

			if (component == 'standards') this.lesson.standards_showing = !this.lesson.standards_showing
			else if (component == 'resources') this.lesson.resources_showing = !this.lesson.resources_showing
			else if (component == 'sparkl') this.lesson.sparkl_showing = !this.lesson.sparkl_showing
			else {
				// for all stages with stumpydivs...
				for (let ref of this.$refs.lc_stumpy_div) {
					// if it's the clicked stage,
					if (ref.uuid.search('-' + component.lc_uuid) > -1) {
						// if this stage's group is currently hidden, we always want to show the full text
						if (!group_showing) {
							ref.show_full = true
						} else {
							// else show the full text if we're toggling on; or hide the full text if we're toggling off
							ref.show_full = (this.last_clicked_component == component)
						}
					} else {
						// for all other (non-clicked) stages, hide the full text
						ref.show_full = false
					}
				}
			}

			// make sure the stage's group is showing
			this.show_group_for_component(component)

			// scroll to the stage iff we opened it
			if (this.last_clicked_component == component) this.scroll_to_stage(component)
		},

		toggle_stage(component) {
			if (this.last_clicked_component == component) {
				this.last_clicked_component = null
			} else {
				this.last_clicked_component = component
				this.scroll_to_stage(component)
			}
		},

		show_standard_in_satchel(start_item) {
			let data = { framework_identifier: '', item_identifier: '' }

			if (start_item?.framework_identifier) {
				data.framework_identifier = start_item.framework_identifier
			} else {
				// if the lesson has a case_framework_identifier, send it
				if (this.lesson.case_framework_identifier) data.framework_identifier = this.lesson.case_framework_identifier

				// HACK: trace up through parents looking for a case_framework_identifier value (e.g. in CourseView); if found, use it
				let parent = this.$parent
				while (parent) {
					if (parent.case_framework_identifier) { data.framework_identifier = parent.case_framework_identifier; break; }
					parent = parent.$parent
				}
			}

			if (start_item?.identifier) {
				data.item_identifier = start_item.identifier
			} else {
				// if the lesson has a course_case_identifier, send it
				if (this.lesson.course_case_identifier) data.item_identifier = this.lesson.course_case_identifier

				// HACK: trace up through parents looking for a course_case_identifier value (e.g. in CourseView); if found, use it as item_identifier
				let parent = this.$parent
				while (parent) {
					if (parent.course_case_identifier) { data.item_identifier = parent.course_case_identifier; break; }
					parent = parent.$parent
				}
			}

			// add current lesson standards as selected items
			if (this.lesson.standards.length > 0) {
				data.selected_items = []
				for (let standard of this.lesson.standards) data.selected_items.push(standard.identifier)
			}

			// set hide_fn to hide the standards chooser if/when the editor is no longer visible
			let show_data = { hide_fn: ()=>{ return ($(vapp.lesson_view_component?.$el).is(':visible') == false) } }

			vapp.$refs.satchel.execute('show', show_data).then(()=>{
				vapp.$refs.satchel.execute('load_framework', data).then(()=>{
				})
			})
		},
	}
}
</script>

<style lang="scss">
// enclosing item should apply an appropriate margin; we only add 4px padding here to make sure shadows show properly
.k-lesson-card-text {
	font-size:16px;
	line-height:20px;
	padding:0!important;
	// padding:4px 0px 12px 0px!important;

	.k-lesson-standard {
		border-top:1px solid #ccc;
		padding-top:5px;
		margin:8px 16px 8px 40px;
		font-size:14px;
		line-height:19px;
		position:relative;
		min-height:24px;
	}

	.k-lesson-standard-child {
		margin-left:24px;
		min-height: none;
	}

	.k-lesson-standard-statement-toggler {
		position:absolute;
		left:-32px;
		top:0px;
	}

	.k-lesson-standard-statement-wrapper {
		// display:flex;
		// align-items: flex-start;
	}

	.k-lesson-standard-statement {
		cursor:pointer;
		font-size:14px;
		line-height: 18px;
	}
	.k-lesson-standard-statement:hover {
		text-decoration:underline;
	}
}

.k-lesson-title {
	font-size:16px;
	line-height:20px;
	// margin-bottom:16px;
}

.v-dialog .k-lesson-title {
	font-size:20px;
}

// PW: SF removed this for some reason; putting it back, at least for now
.k-lesson-course-unit-header {
	font-size:12px;
	line-height:15px;
	font-weight:bold;
	color:#999;
	margin-left:8px;
	text-align:center;
}

.k-lesson-course-unit-header-inner {
	font-size:9px;
	line-height:12px;
	font-weight:bold;
	border-radius:6px;
	padding:2px 3px;
	background-color:#fff;
	color:#000;
	border:1px solid #999;
}

.k-mycontent-item-outer-showing {
	.k-lesson-course-unit-header-inner {
		font-size:12px;
		line-height:15px;
		padding:4px 6px;
	}
}

.k-lesson-date-header {
	display:inline-block;
	white-space:nowrap;
	font-size:13px;
	line-height:15px;
	font-weight:bold;
	background-color:#999;	// this will get overwritten
	border-radius:6px;
	padding:4px 6px;
	color:#fff;
	text-align:center;
}
.k-lesson-date-header-date {
	// letter-spacing: 1px;
}

.k-lesson-date-header-grey { background-color: $v-grey-darken-2; }
.k-lesson-date-header-teal { background-color: $v-teal-darken-2; }
.k-lesson-date-header-amber { background-color: $v-amber-darken-4; }
.k-lesson-date-header-red { background-color: $v-red-darken-2; }


// .k-lesson-date-header {
// 	white-space:nowrap;
// 	font-size:14px;
// 	line-height:15px;
// 	font-weight:900;
// 	background-color:#999;	// this will get overwritten
// 	border-radius:6px;
// 	padding:4px 6px;
// 	color:#fff;
// 	margin-left:8px;
// 	text-align:center;
// }

.k-lesson-title-intro {
	font-weight:bold;
	font-size:14px;
	text-transform: uppercase;
	// font-variant: small-caps;
	color:$v-indigo-darken-2;
	margin-right:8px;
}

.k-lesson-component {
	border:1px solid $v-amber-darken-2;
	border-radius:7px;
	margin-top: 8px;
	color:#222;
	background-color:#fff;
}

.k-lesson-component-title {
	display:flex;
	cursor:pointer;
	font-size:16px;
	line-height:20px;
	.k-lesson-component-toggle-holder {
		border-radius:6px 0 0 6px;
		background-color:$v-amber-lighten-3;
		flex:0 1 auto;
		padding:4px 0 3px 4px;
	}
	.k-lesson-component-title-text {
		font-weight:bold;
		background-color:$v-amber-lighten-3;
		color:#222;
		padding:6px 6px;
		flex: 1 0 auto;
	}
	.k-lesson-component-title-text-0 {
		border-radius:0 6px 6px 0;
	}
	.k-lesson-component-title-weight {
		border-radius:0 6px 6px 0;
		background-color:$v-orange-darken-3;
		color:#fff;
		padding:6px 6px;
		flex:0 1 auto;
		text-align:right;
	}
}

.k-lesson-component-guidance, .fr-view.k-lesson-component-guidance {
	color:#555;
	font-size:12px;
	line-height:15px;
	padding: 0 8px;
}

.k-lesson-component-content {
	color:#222;
	font-size:14px;
	line-height:19px;
	margin-top:12px;
	padding: 0 8px 8px 8px;

	li {
		margin-bottom:6px;
	}
}

.k-lesson-component-part-header {
	display:flex;
	align-items: center;
	font-weight:900;
	margin:12px 0 8px 0;
	background-color:$v-amber-accent-1;
	border-radius:6px;
	padding:3px 5px 3px 8px;
}

.k-lesson-component-part-content {
	padding:0 4px;
}

// .k-lesson-component-part-content:last-of-type {
// 	border-bottom:0;
// 	margin-bottom:0;
// }

.k-lesson-component-default-content {
	color:#555;
	font-size:12px;
	line-height:15px;
	margin-top:12px;
	padding: 0 8px;
}

.k-lesson-component-showing {
	.k-lesson-component-title {
		.k-lesson-component-toggle-holder {
			border-radius:6px 0 0 0;
		}
		.k-lesson-component-title-text-0 {
			border-radius:0 6px 0 0;
		}
		.k-lesson-component-title-weight {
			border-radius:0 6px 0 0;
		}
	}
}

.k-lesson-component-part-activity {
	flex:0 0 auto;
	// max-width:200px;
	border:2px solid $v-pink-darken-2;
	border-radius:10px;
	margin:4px;
	background-color:$v-pink-lighten-5;
}

.k-lesson-component-part-activity-expanded {
	flex:1 0 100%;
	margin:4px 0;
	max-width:none;
	// width:calc(100% - 8px);
}

.k-lesson-component-resource-link, .k-lesson-component-resource-link-placeholder {
	background-color:#555;
	color:#fff;
	padding:2px 8px;
	border-radius:5px!important;
	margin:0 4px!important;
	display:inline-block;
	height:20px;
	font-size:16px;
	cursor:pointer;
}

.k-lesson-component-resource-anchor-link {

}

.k-lesson-component-instructions {
	background-color:#ddd;
	padding:4px 8px;
	font-style: italic;
	border-radius:4px;
	font-size:0.9em;
	line-height:1.2em;
}

.k-lesson-grouping {
	border-radius:6px;
	// border:1px solid #ccc;
	background-color:$v-amber-lighten-5;
	padding:8px;
	margin:12px 0 0 0;
}

.k-lesson-resource-collection {
	display:flex;
	flex-wrap: wrap;
	align-items: stretch;

	.k-resource-collection-activity-wrapper {
		min-width:25%;
		max-width:25%;
	}
}

.k-last-lesson-quick-look-resource {
	background-color:$v-amber-accent-3;
	color:#000;
}

.k-lesson-standard-fullstatement {
	// when we render standard fullstatements using U.render_latex, it may return the statement in a paragraph tag; we don't want that p to have a margin-top here
	p { margin-top:0!important; }
}

.k-lesson-standard-suppinfo {
	background-color:#fff;
	// padding:8px 8px 8px 8px;
	border-radius:6px;
	margin-top:12px;
	border:1px solid $v-amber-darken-4;
}

.k-lesson-standard-suppinfo-header {
	text-align:center;
	border-bottom:1px solid $v-amber-darken-4;
	// background-color:#333;
	// color:#fff;
	background-color:$v-amber-darken-1;
	color:#000;
	border-radius:5px 5px 0 0;
	padding:4px;
	margin-bottom:4px;
}

///////////////////////////
// below are copied from Satchel
.k-exemplar-block-header {
	margin:8px 0 4px 0;
	border-top:1px solid #999;
	padding-top:8px;
	cursor:pointer;

	// paragraphs inside k-exemplar-block-header should be treated as inline-block
	p {
		margin:0;
		display:inline-block;
	}

	.fas {
		font-size:18px;
		line-height:16px;
		width:15px;
		color:$v-grey-darken-2;
		text-align:center;
	}
}
.k-exemplar-block-header:first-of-type {
	border-top:0;
	padding-top:0;
	margin-top:4px;
}

.k-exemplar-block-body {
}

.k-exemplar-block-body-no-header {
	margin:8px 0;
	border-top:1px solid #999;
	padding-top:8px;
}

.k-exemplar-block-body-no-header:first-of-type {
	border-top:0;
	padding-top:0;
	margin-top:4px;
}

.k-section-text-copy-btn {
	float:left;
	margin-right:6px;
	cursor:pointer;
}

.k-overview-sub-component {
	display:flex;
	align-items:start;
	p {
		margin:0!important;
		display:inline;
	}
}

.k-lpe-author-note {
	background-color:#222;
	color:#fff;
	text-align:center;
	padding:8px 0;
	a {
		font-weight:bold;
		color:#fff!important;
	}
}
</style>
